function handleAccordionClick() {
  	let acc = event.currentTarget;
    acc.classList.toggle("id-active");
    var panel = acc.nextElementSibling;
    
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } 
    else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
}